// LOGIN
export const POST_JWT_LOGIN = '/api/user/login';
export const POST_JWT_REFRESH = '/api/user/refresh';
export const POST_PASSWORD_RESET = '/api/user/reset';
export const GET_ROLES = '/api/user/roles';
export const PUT_USER_PREFERENCES = '/api/user/preferences';

// Log
export const GET_LOG_EXCEPTIONS = '/api/log/exceptions';
export const GET_SCRAP_RECORDS = '/api/warehouse/ops/scrapRecords';
export const GET_SCRAP_RECORDS_SINCE = '/api/warehouse/ops/scrapRecordsSince';
export const GET_LOCATION_LOGS = '/api/warehouse/location/logs';
export const GET_LOCATION_LOG_USERS = '/api/warehouse/location/logs/users';

// Settings
export const GET_SMTP_AGENTS = '/api/mail/oauth2/agents';
export const POST_SMTP_AGENT = '/api/mail/oauth2/agent/create';
export const POST_SMTP_TEST_FIRE = '/api/mail/oauth2/agent/test';

// USER profile
export const POST_EDIT_JWT_PROFILE = '/post-jwt-profile';
export const POST_EDIT_PROFILE = '/post-fake-profile';
export const GET_USER_PROFILE = '/user';

// Users
export const GET_USERS = '/api/user';

// Customer Service
export const GET_TICKETS = '/api/customerService/tickets';
export const GET_TICKET = '/api/customerService/ticket/:id';
export const GET_TICKET_MESSAGES = '/api/customerService/ticket/:id/messages';
export const GET_CHECK_MESSAGES = '/api/customerService/tickets/checkForMessages';
export const POST_TICKET = '/api/customerService/tickets/saveNormal';
export const POST_DELETE_TICKET = '/api/customerService/ticket/:id/delete';
export const POST_TICKET_MESSAGE = '/api/customerService/ticket/:id/message/post';
export const GET_TICKET_MESSAGE_ATTACHMENT = '/api/customerService/tickets/attachment/:id';
export const POST_TICKET_SUBSCRIPTION = '/api/customerService/ticket/:id/subscription';

// Items
export const GET_ITEM = '/api/items/get';
export const GET_ITEM_BY_SKU = '/api/items/sku/:sku';
export const GET_ITEMS = '/api/items';
export const POST_ITEM = '/api/items/create';
export const DELETE_ITEM = '/api/items/delete';

// Trucks
export const GET_TRUCKS = '/api/sourcing/trucks';

// Suppliers
export const GET_SUPPLIERS = '/api/sourcing/suppliers';
export const POST_SUPPLIER = '/api/sourcing/suppliers/save';
export const DELETE_SUPPLIER = '/api/sourcing/suppliers/delete';
export const GET_SUPPLIER_ITEM = '/api/sourcing/supplier/item';
export const GET_SUPPLIER_ITEMS = '/api/sourcing/supplier/items';
export const POST_SUPPLIER_ITEM = '/api/sourcing/supplier/item/save';
export const DELETE_SUPPLIER_ITEM = '/api/sourcing/supplier/item/delete';

// Orders
export const GET_ORDERS = '/api/sourcing/orders';
export const GET_ORDERS_BY_ITEM = '/api/sourcing/ordersByItem';
export const POST_ORDER = '/api/sourcing/orders/save';
export const DELETE_ORDER = '/api/sourcing/orders/delete';

// Devices
export const GET_DEVICES = '/api/devices';
export const POST_DEVICES = '/api/devices/save';
export const DELETE_DEVICES = '/api/devices/delete';

// Directory
export const GET_DIRECTORY_ENTRIES = '/api/directory/entries';
export const GET_DIRECTORY_ENTRY = '/api/directory/entry';
export const POST_DIRECTORY_ENTRY = '/api/directory/entries/save';
export const DELETE_DIRECTORY_ENTRY = '/api/directory/entries/delete';

// Google
export const GOOGLE_POST_FILES = '/api/google/filesupload';

// Listings
export const GET_LISTINGS = '/api/listings';
export const POST_LISTING = '/api/listings/save';
export const DELETE_LISTING = '/api/listings/delete';

// Proiles
export const GET_PROFILES = '/api/profiles';
export const GET_PROFILE = '/api/profiles/:id';
export const POST_PROFILE = '/api/profiles/save';

// Notice
export const GET_NOTIFICATIONS = '/api/notify';
export const POST_NOTIFICATION = '/api/notify/save';

// Azure
export const GET_MICROSOFT_AUTHORIZATIONS = '/api/microsoft/authorizations';
export const GET_MICROSOFT_APPS = '/api/microsoft/apps';
export const DELETE_MICROSOFT_AUTHORIZATION = '/api/microsoft/authorizations/delete';
export const POST_MICROSOFT_AUTHORIZATION = '/api/microsoft/authorization/save';
